import React from 'react';
import SeeWhatItsLike from "../../../components/SeeWhatItsLike";
import img1 from "./1.png";
import img2 from "./2.png";
import img3 from "./3.png";
export default function ServiceLibrarySeeWhatItsLike() {
  return /*#__PURE__*/React.createElement(SeeWhatItsLike, {
    steps: [{
      title: 'Well-defined services = organized business',
      subtitle: 'Create services with predefined pricing and billing. These will serve as your building blocks, enabling you to quickly plug services into proposals or agreements.',
      image: {
        src: img1,
        height: 1246,
        width: 702
      }
    }, {
      title: 'Send the ultimate proposal',
      subtitle: 'Select services from your library, mix and match per client need, and send customized proposals to your clients.',
      image: {
        src: img2,
        height: 1246,
        width: 748
      }
    }, {
      title: 'Get your proposals approved faster',
      subtitle: 'Customize services per proposal to cover specific client needs, reduce negotiations, and eliminate back-and-forth.',
      image: {
        src: img3,
        height: 1246,
        width: 748
      }
    }]
  });
}